import { render, staticRenderFns } from "./ApproveVideoModal.vue?vue&type=template&id=dd4981e8&"
import script from "./ApproveVideoModal.vue?vue&type=script&lang=js&"
export * from "./ApproveVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveVideoModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports